<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import {
        ROUTE_TYPE,
        LOCATION_TYPE,
        CUSTOMER_TYPES,
        TRANSFER_STATUSES,
        PAYMENT_TYPES
    } from "../lib/constants";
    import {formatDate} from "../lib/lib";
    import A from "../lib/Router/A.svelte";
    import Modal from "../components/modal/Modal.svelte";

    export let transferId = null;

    let transfer = null;
    let flightLabel = '';
    let vehicles = {}

    const load = () => {
        const onSuccess = result => {
            transfer = result;

            vehicles = {};
            transfer.vehicles.map(item => {
                if (!vehicles[item.vehicle_type_id]) {
                    vehicles[item.vehicle_type_id] = {
                        name: app.vehicleTypeName(item.vehicle_type_id),
                        total: 1
                    }
                } else {
                    vehicles[item.vehicle_type_id].total++;
                }
            });

            if (transfer.route_type == ROUTE_TYPE.ARRIVAL && transfer.pickup) {
                if (transfer.pickup.type_id == LOCATION_TYPE.AIRPORT) {
                    flightLabel = "AR. FLIGHT NO";
                } else if (transfer.pickup.type_id == LOCATION_TYPE.PORT) {
                    flightLabel = "AR. BOAT NAME";
                }
            } else if (transfer.route_type == ROUTE_TYPE.DEPARTURE && transfer.drop) {
                if (transfer.drop.type_id == LOCATION_TYPE.AIRPORT) {
                    flightLabel = "DEP. FLIGHT NO";
                } else if (transfer.drop.type_id == LOCATION_TYPE.PORT) {
                    flightLabel = "DEP. BOAT NAME";
                }
            }
        }

        const onFailure = err => {
            transferId = -1;
        };

        R.handle(R.transfer.details, transferId, onSuccess, onFailure, LOADER.POPUP);
    }

    const loadGroupTransfer = () => {
        transferId = transfer.group_id;
        transfer = null;

        setTimeout(() => {
            load();
        }, 200);
    }

    const close = (param) => {
        transfer = null;

        if (param instanceof Event) {
            transferId = null;
            return;
        }

        setTimeout(() => {
            transferId = null;
        }, 200);
    }

    load();
</script>

{#if transfer}
    <Modal title="Transfer {transfer.code }" on:close="{ close }">
        <div slot="body">
            <div class="fs-6 mb-2">{ formatDate(transfer.transfer_at, 'd-m-y H:i') }</div>
            <div class="d-flex align-items-top justify-content-between mb-3">
                <div>
                    <h6 class="mb-0">{ transfer.pickup_name }</h6>
                    {#if transfer.pickup_address}
                        <div class="text-gray">
                            { transfer.pickup_address }
                        </div>
                    {/if}
                </div>
                <div class="fs-5">&#10140;</div>
                <div>
                    <h6 class="mb-0">{ transfer.drop_name }</h6>
                    {#if transfer.drop_address}
                        <div class="text-gray">
                            { transfer.drop_address }
                        </div>
                    {/if}
                </div>
            </div>
            <table class="table table-list transfer-view">
                <tbody>
                {#if transfer.flight_no}
                    <tr>
                        <th>{ flightLabel }</th>
                        <td class="text-gray">
                            { transfer.flight_no }
                        </td>
                    </tr>
                {/if}
                <tr>
                    <th>PASSENGERS</th>
                    <td>
                        <div class="d-flex">
                            <div class="column text-center">
                                <div class="small">Total</div>
                                <strong>{ transfer.passengers }</strong>
                            </div>
                            <div class="column text-gray text-center">
                                <div class="small">Adults</div>
                                { transfer.adults }
                            </div>
                            {#if transfer.children > 0}
                                <div class="column text-gray text-center">
                                    <div class="small">Children</div>
                                    { transfer.children }
                                </div>
                            {/if}
                            {#if transfer.infants > 0}
                                <div class="column text-gray text-center">
                                    <div class="small">Infants</div>
                                    { transfer.infants }
                                </div>
                            {/if}
                        </div>
                    </td>
                </tr>
                {#if transfer.booster_seats > 0 || transfer.baby_seats > 0 || transfer.infant_seats > 0}
                    <tr>
                        <th>SEATS</th>
                        <td>
                            <div class="d-flex">
                                {#if transfer.booster_seats > 0}
                                    <div class="column text-gray text-center">
                                        <div class="small">Boosters</div>
                                        { transfer.booster_seats }
                                    </div>
                                {/if}
                                {#if transfer.baby_seats > 0}
                                    <div class="column text-gray text-center">
                                        <div class="small">Baby</div>
                                        { transfer.baby_seats }
                                    </div>
                                {/if}
                                {#if transfer.infant_seats > 0}
                                    <div class="column text-gray text-center">
                                        <div class="small">Infant</div>
                                        { transfer.infant_seats }
                                    </div>
                                {/if}
                            </div>
                        </td>
                    </tr>
                {/if}

                <tr>
                    <th>CUSTOMER</th>
                    <td class="text-gray">
                        { transfer.customer.fullname }
                    </td>
                </tr>
                {#if transfer.customer.phone}
                    <tr>
                        <th>PHONE</th>
                        <td class="text-gray">
                            <a href="tel:{ transfer.customer.phone }">{ transfer.customer.phone }</a>
                        </td>
                    </tr>
                {/if}
                {#if transfer.customer.email}
                    <tr>
                        <th>EMAIL</th>
                        <td class="text-gray">
                            <a href="mailto:{ transfer.customer.email }">{ transfer.customer.email }</a>
                        </td>
                    </tr>
                {/if}
                {#if transfer.hotel}
                    <tr>
                        <th>HOTEL</th>
                        <td class="text-gray">
                            { transfer.hotel.name }
                        </td>
                    </tr>
                {/if}
                {#if transfer.customer.room_no}
                    <tr>
                        <th>ROOM NO</th>
                        <td class="text-gray">
                            { transfer.customer.room_no }
                        </td>
                    </tr>
                {/if}
                {#if transfer.department}
                    <tr>
                        <th>DEPARTMENT</th>
                        <td class="text-gray">
                            { transfer.department.name }
                        </td>
                    </tr>
                {/if}
                <tr>
                    <th>CUSTOMER TYPE</th>
                    <td class="text-gray">
                        { CUSTOMER_TYPES[transfer.customer_type] }
                    </td>
                </tr>
                <tr>
                    <th>PAYMENT TYPE</th>
                    <td class="text-gray">
                        { PAYMENT_TYPES[transfer.payment_type] }
                    </td>
                </tr>
                <tr>
                    <th>PRICE</th>
                    <td class="text-gray">
                        { transfer.price } €
                    </td>
                </tr>

                <tr>
                    <th>VEHICLES</th>
                    <td class="text-gray">
                        {#each Object.keys(vehicles) as key}
                            <div>
                                { vehicles[key].total } x { vehicles[key].name }
                            </div>
                        {/each}
                    </td>
                </tr>
                <tr>
                    <th>CREATED</th>
                    <td class="text-gray">
                        { formatDate(transfer.created_at, 'd-m-y H:i') }
                    </td>
                </tr>
                <tr>
                    <th>STATUS</th>
                    <td class="text-gray">
                        { TRANSFER_STATUSES[transfer.status_id] }
                    </td>
                </tr>

                </tbody>
            </table>

            {#if transfer.notes}
                <div class="mt-3 fst-italic">{@html transfer.notes.replaceAll("\n", "<br>") }</div>
            {/if}

            <div class="row mt-4">
                <div class="col">
                    {#if transfer.group_transfer}
                        {#if transfer.group_transfer.route_type == ROUTE_TYPE.DEPARTURE}
                            <button class="btn btn-primary" on:click={ loadGroupTransfer }>OPEN DEPARTURE</button>
                        {:else if transfer.group_transfer.route_type == ROUTE_TYPE.ARRIVAL}
                            <button class="btn btn-primary" on:click={ loadGroupTransfer }>OPEN ARRIVAL</button>
                        {/if}
                    {:else if transfer.route_type == ROUTE_TYPE.ARRIVAL}
                        <A href="/app/departure/{ transfer.id }" class="btn btn-danger btn-lg me-2">
                            CREATE DEPARTURE
                        </A>
                    {/if}
                </div>
                <div class="col text-end">
                    <div class="btn btn-link me-2" on:click="{ () => close() }">Close</div>
                </div>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .transfer-view th {
        vertical-align: middle;
        padding-left: 0;
    }

    .transfer-view th, .transfer-view td {
        border-bottom: var(--border-light);
    }

    .transfer-view .column {
        padding: 0 10px;
    }

    .transfer-view .column:first-child {
        padding-left: 0;
    }

    .transfer-view .column:last-child {
        padding-right: 0;
    }
</style>